require('./bootstrap');

var Chartist = require('chartist');

window.Chartist = Chartist;
import Litepicker from 'litepicker';
//require('select2');



